module.exports = __webpack_public_path__ + "img/SH.ce205f36.png";